import { render } from "./FaqServiceComp.vue?vue&type=template&id=d21373ba&scoped=true&ts=true"
import script from "./FaqServiceComp.vue?vue&type=script&lang=ts"
export * from "./FaqServiceComp.vue?vue&type=script&lang=ts"

import "./FaqServiceComp.vue?vue&type=style&index=0&id=d21373ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d21373ba"]])

export default __exports__